import React, { useState } from "react";
import User from '../model/User'

interface AuthContextType {
    setIsLoggedContext: (value : boolean) => void;
    setUserInstance: (value : any) => void;
    setWidthContext: (value : number) => void;
    isLogged : boolean
    user : User;
    width : number;
    isMobileWidth : boolean
}
  
let AuthContext = React.createContext<AuthContextType>(null!);

export function useCustomContext() {
    return React.useContext(AuthContext);
}

export default function AuthProvider({ children }: { children: React.ReactNode }) {
    const [isLogged, setIsLogged] = useState(false);
    const [user, setUser] = useState<User>(new User('', '', '', '', false))
    const [width, setWindowWidth] = useState(0);

    const isMobileWidth = 375 > width


    const setIsLoggedContext = (value : boolean) : void=> {
        setIsLogged(value)
    }

    const setUserInstance = (value: User) : void => {
        setUser(value)
    }

    const setWidthContext = (value: number) : void => {
        setWindowWidth(value)
    }
    
    let value = { isLogged, setIsLoggedContext, setUserInstance, user, width, setWidthContext, isMobileWidth};

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}


